export default __webpack_public_path__ + "static/media/red-bull.d1d28529.png";